module.exports = __webpack_public_path__ + "assets/img/西安.f35c6b21.jpg";